import { lazy } from 'react';

const ContactUs = lazy(() => import('./ContactUs'));

export default ContactUs;
